module.exports = __webpack_public_path__ + "static/img/can-blackberry.3dbb4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-blackberry.png
// module id = pOo7
// module chunks = 0